import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import { changelogFor } from '../cameraData';

/**
 * Firmware history for one camera: release svnlog entries whose commit
 * message names this camera's platform id.
 */
export default class CameraChangelogModal extends Modal {
  className() {
    return 'CameraChangelogModal Modal--large';
  }

  title() {
    return app.translator.trans('acseven-chdk-cameras.forum.changelog.title', {
      name: this.attrs.camera.name,
    });
  }

  content() {
    const entries = this.entries();

    return (
      <div className="Modal-body">
        {entries.length === 0 ? (
          <p>{app.translator.trans('acseven-chdk-cameras.forum.changelog.empty')}</p>
        ) : (
          <ul className="CameraChangelog">
            {entries.map((entry) => (
              <li className="CameraChangelog-entry">
                <div className="CameraChangelog-meta">
                  <span className="CameraChangelog-revision">r{entry.revision}</span>
                  <span className="CameraChangelog-date">
                    {entry.utc ? new Date(entry.utc).toLocaleDateString() : ''}
                  </span>
                  <span className="CameraChangelog-author">{entry.author}</span>
                </div>
                <div className="CameraChangelog-msg">{entry.msg}</div>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  entries() {
    return changelogFor(this.attrs.camera);
  }
}
